class Popup extends HTMLElement {
    constructor() {
        super()
        this.timeToDisplay = this.getAttribute('time-to-display')
    }

    connectedCallback() {
        setTimeout(() => {
            this.show()
        }, parseInt(this.timeToDisplay) || 0);

        this.querySelector('.close-button').addEventListener('click', ()=> {
            this.close()
        })
    }

    close () {
        this.setAttribute('show', "false")
    }

    show () {
        this.setAttribute('show', "true")
    }
}

customElements.define('pop-up', Popup)